import request from '@/utils/request'
import axios from "axios";

export function addProduct(data) {
    return request({
        url: '/produce/add',
        method: 'post',
        data
    })
}
export function getProductList(params) {
    return request({
        url: '/produce/all',
        method: 'get',
        params
    })
}
export function updateProduct(data) {
    return request({
        url: '/produce/update',
        method: 'post',
        data
    })
}
export function batchUpdateProducts(data) {
    return request({
        url: '/produce/batchUpdate',
        method: 'post',
        data
    })
}
export function importProducts(data) {
    return request({
        url: '/produce/import',
        method: 'post',
        data,
    })
}
export function createInbound(data) {
    return request({
        url: '/inbound/create',
        method: 'post',
        data
    })
}
export function updateInbound(data) {
    return request({
        url: '/inbound/update',
        method: 'post',
        data
    })
}
export function getInboundList(params) {
    return request({
        url: '/inbound/all',
        method: 'get',
        params
    })
}
export function queryProductsWithInventory(data){
    return request({
        url: '/produce/with-inventory',
        method: 'post',
        data
    })
}

/**
 * 上架：将待上架库存转为可售库存
 */
export function shelvesStock(data) {
    return request({
        url: '/produce/shelves',
        method: 'post',
        data
    })
}

/**
 * 分配出库：将可售库存转为待出库
 */
export function allocateStock(data) {
    return request({
        url: '/produce/allocate',
        method: 'post',
        data
    })
}

/**
 * 确认出库：将待出库转为已出库
 */
export function confirmOutbound(data) {
    return request({
        url: '/produce/confirm-outbound',
        method: 'post',
        data
    })
}

/**
 * 标记不良品
 */
export function markDefective(data) {
    return request({
        url: '/produce/mark-defective',
        method: 'post',
        data
    })
}

/**
 * 导出选中的入库单数据
 * @param {Array} ids - 选中的入库单ID数组
 */
export function exportSelectedInbound(ids) {
    return request({
        url: '/inbound/exportSelected',
        method: 'post',
        data: ids,
        responseType: 'blob' // 关键：指定响应类型为二进制流
    })
}

/**
 * 批量审核入库单
 * 根据入库类型自动确定目标状态：
 * - 中转代发 -> 头程在途
 * - 自发头程 -> 转运中
 * @param {Array} ids - 选中的入库单ID数组
 */
export function batchAuditInbound(ids) {
    return request({
        url: '/inbound/batchAudit',
        method: 'post',
        data: ids
    })
}

/**
 * 批量废弃入库单
 * @param {Array} ids - 选中的入库单ID数组
 */
export function batchDiscardInbound(ids) {
    return request({
        url: '/inbound/batchDiscard',
        method: 'post',
        data: ids
    })
}

/**
 * 获取入库单详情（用于打印）
 * @param {Number} id - 入库单ID
 */
export function getInboundOrderDetail(id) {
    return request({
        url: `/inbound/${id}`,
        method: 'get'
    })
}
export function uploadImage(file) {
    const formData = new FormData();
    formData.append('file', file); // 'file' 需与后端 @RequestParam("file") 对应
    return request({
        url: '/api/upload',
        method: 'post',
        data: formData,
        // 重要：设置请求头，告知后端这是表单数据
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
}
export function createOrderWithItems(data){
    return request({
        url: '/orders/createOrderWithItems',
        method: 'post',
        data
    })
}
export function updateInventory(data) {
    return request({
        url: '/produce/update-inventory',
        method: 'post',
        data
    })
}
export function getOrderWithItemsPage(params) {
    return request({
        url: '/orders/getOrderWithItemsPage',
        method: 'get',
        params
    })
}

// 提交订单（更新状态为待审核，并计算费用）
export function submitOrder(orderNo) {
    return request({
        url: '/orders/submitOrder',
        method: 'post',
        params: { orderNo }
    })
}

// 提交并审核订单（更新状态为待发货，并计算费用）
export function submitAndApproveOrder(orderNo) {
    return request({
        url: '/orders/submitAndApproveOrder',
        method: 'post',
        params: { orderNo }
    })
}

// 批量审核订单
export function batchApproveOrders(orderNos) {
    return request({
        url: '/orders/batchApproveOrders',
        method: 'post',
        data: orderNos
    })
}

// 更新订单
export function updateOrder(data) {
    return request({
        url: '/orders/updateOrder',
        method: 'post',
        data
    })
}
export function exportInventoryAll(params) {
    return request({
        url: '/produce/inventory/export/all',
        method: 'get',
        params,
        responseType: 'blob', // 必须保留，告诉axios返回二进制流
        timeout: 60000,
    }).then(response => {
        // 1. 解析后端返回的文件名（适配修复后的filename*=UTF-8''格式）
        const contentDisposition = response.headers['content-disposition'];
        let fileName = `产品库存_${new Date().getTime()}.xlsx`; // 兜底

        if (contentDisposition) {
            // 匹配 filename*=UTF-8'' 后的编码内容
            const fileNameMatch = contentDisposition.match(/filename\*=UTF-8''(.*)/);
            if (fileNameMatch && fileNameMatch.length > 1) {
                // 解码并补全.xlsx后缀（因为后端buildFileName移除了）
                fileName = decodeURIComponent(fileNameMatch[1]) + '.xlsx';
            }
        }

        // 2. 关键修复：Blob的数据源是response.data（二进制流），而非整个response对象
        const blob = new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });

        // 3. 下载逻辑（保持不变）
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        link.click();
        window.URL.revokeObjectURL(url);

        return response;
    }).catch(error => {
        // 补充：二进制响应的错误处理（解析后端的异常信息）
        console.error('导出失败:', error);
        if (error.response?.data instanceof Blob) {
            const reader = new FileReader();
            reader.onload = () => {
                const errorText = reader.result || '导出数据量过大或服务器异常';
                throw new Error(errorText);
            };
            reader.readAsText(error.response.data);
        } else {
            throw new Error(error.message || '导出失败，请联系管理员');
        }
    });
}

/**
 * OSS单文件上传
 * @param {File} file - 文件对象
 * @param {String} folder - 上传目录（可选）
 */
export function ossUploadFile(file, folder = 'attachments') {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('folder', folder);
    return request({
        url: '/api/oss/upload',
        method: 'post',
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
}

/**
 * OSS多文件上传
 * @param {Array} files - 文件数组
 * @param {String} folder - 上传目录（可选）
 */
export function ossUploadMultipleFiles(files, folder = 'attachments') {
    const formData = new FormData();
    files.forEach(file => {
        formData.append('files', file);
    });
    formData.append('folder', folder);
    return request({
        url: '/api/oss/uploadMultiple',
        method: 'post',
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
}

/**
 * OSS删除文件
 * @param {String} fileUrl - 文件URL
 */
export function ossDeleteFile(fileUrl) {
    return request({
        url: '/api/oss/delete',
        method: 'post',
        data: { fileUrl }
    });
}

// ===================== 订单拦截相关API =====================

/**
 * 创建订单拦截
 * @param {Object} data - 拦截信息 { orderNo, userId, interceptReason, createBy }
 */
export function createOrderIntercept(data) {
    return request({
        url: '/orderIntercept/create',
        method: 'post',
        data
    });
}

/**
 * 根据订单号查询拦截记录
 * @param {String} orderNo - 订单号
 */
export function getInterceptByOrderNo(orderNo) {
    return request({
        url: '/orderIntercept/getByOrderNo',
        method: 'get',
        params: { orderNo }
    });
}

/**
 * 检查订单是否被拦截（用于WMS打包检查）
 * @param {String} orderNo - 订单号
 */
export function checkOrderIntercept(orderNo) {
    return request({
        url: '/orderIntercept/checkIntercept',
        method: 'get',
        params: { orderNo }
    });
}

/**
 * 完成拦截操作
 * @param {String} orderNo - 订单号
 * @param {String} completeBy - 完成操作人
 * @param {Boolean} success - 是否成功
 * @param {String} remark - 备注
 */
export function completeOrderIntercept(orderNo, completeBy, success, remark) {
    return request({
        url: '/orderIntercept/complete',
        method: 'post',
        params: { orderNo, completeBy, success, remark }
    });
}

/**
 * 标记拦截失败
 * @param {String} orderNo - 订单号
 * @param {String} remark - 备注
 */
export function markInterceptFailed(orderNo, remark) {
    return request({
        url: '/orderIntercept/markFailed',
        method: 'post',
        params: { orderNo, remark }
    });
}

/**
 * 分页查询拦截记录
 * @param {Object} params - { current, size, status, userId }
 */
export function getInterceptList(params) {
    return request({
        url: '/orderIntercept/list',
        method: 'get',
        params
    });
}

// ==================== 充值管理相关接口 ====================

/**
 * OMS - 查询充值记录列表
 */
export function getOmsRechargeList(params) {
    return request({
        url: '/oms/recharge/list',
        method: 'get',
        params
    });
}

/**
 * OMS - 根据ID查询充值记录详情
 */
export function getOmsRechargeById(id) {
    return request({
        url: `/oms/recharge/${id}`,
        method: 'get'
    });
}

/**
 * OMS - 新增充值申请
 */
export function addOmsRecharge(data) {
    return request({
        url: '/oms/recharge',
        method: 'post',
        data
    });
}

/**
 * OMS - 修改充值记录
 */
export function updateOmsRecharge(data) {
    return request({
        url: '/oms/recharge',
        method: 'put',
        data
    });
}

/**
 * OMS - 删除充值记录
 */
export function deleteOmsRecharge(ids) {
    return request({
        url: `/oms/recharge/${ids}`,
        method: 'delete'
    });
}

/**
 * WMS - 查询充值记录列表
 */
export function getWmsRechargeList(params) {
    return request({
        url: '/wms/recharge/list',
        method: 'get',
        params
    });
}

/**
 * WMS - 根据ID查询充值记录详情
 */
export function getWmsRechargeById(id) {
    return request({
        url: `/wms/recharge/${id}`,
        method: 'get'
    });
}

/**
 * WMS - 审核充值记录
 */
export function auditRecharge(data) {
    return request({
        url: '/wms/recharge/audit',
        method: 'post',
        data
    });
}

/**
 * WMS - 批量审核充值记录
 */
export function batchAuditRecharge(data) {
    return request({
        url: '/wms/recharge/audit/batch',
        method: 'post',
        data
    });
}

/**
 * WMS - 删除充值记录
 */
export function deleteWmsRecharge(ids) {
    return request({
        url: `/wms/recharge/${ids}`,
        method: 'delete'
    });
}

// ==================== 物流产品相关接口 ====================

/**
 * 获取物流产品列表（分页）
 */
export function getLogisticsProducts(params) {
    return request({
        url: '/logisticsProduct/list',
        method: 'get',
        params
    });
}

/**
 * 获取启用状态的物流产品列表
 */
export function getActiveLogisticsProducts() {
    return request({
        url: '/logisticsProduct/listActive',
        method: 'get'
    });
}

// ==================== 退件单相关接口 ====================

/**
 * 创建退件单
 * @param {Object} data - 退件单信息（包含明细）
 */
export function createReturnOrder(data) {
    return request({
        url: '/returnOrder/create',
        method: 'post',
        data
    });
}

/**
 * 根据退件单号查询退件单详情
 * @param {String} returnNo - 退件单号
 */
export function getReturnOrderDetail(returnNo) {
    return request({
        url: `/returnOrder/detail/${returnNo}`,
        method: 'get'
    });
}

/**
 * 分页查询退件单列表
 * @param {Object} params - { current, size, userId, state }
 */
export function getReturnOrderList(params) {
    return request({
        url: '/returnOrder/list',
        method: 'get',
        params
    });
}

/**
 * 更新退件单状态
 * @param {String} returnNo - 退件单号
 * @param {Integer} state - 新状态
 */
export function updateReturnOrderState(returnNo, state) {
    return request({
        url: '/returnOrder/updateState',
        method: 'post',
        params: { returnNo, state }
    });
}

/**
 * 批量审核退件单
 * @param {Array} returnNos - 退件单号数组
 */
export function batchAuditReturnOrders(returnNos) {
    return request({
        url: '/returnOrder/batchAudit',
        method: 'post',
        data: returnNos
    });
}

/**
 * 更新退件单
 * @param {Object} data - 退件单信息（包含明细）
 */
export function updateReturnOrder(data) {
    return request({
        url: '/returnOrder/update',
        method: 'post',
        data
    });
}
